export default "__VITE_ASSET__692fda98__"